<div class="container-fluid">
    <div class="col-md-12" *ngIf="isLoading">
        <app-busy [message]="message"></app-busy>
    </div>
    
    <div class="page_header">
        <h1 class="heading">Manage Activities</h1>
    </div>

    <div class="row">
        <div class="col">
          <app-filter
            [formConfig]="filterConfig"
            (formValueChanged)="applyFilter($event)"
            [selectedItems]="selectedItems"
          ></app-filter>
        </div>
      </div>

        <div class="table-responsive">
            <!-- Table Actions -->
			<app-actions [actions]="wfManageActions" (actionEvent)="doPermitAction($event)"></app-actions>
			<!-- End Table Actions -->
            <table class="table table-sm custom_table">
                <thead class="thead-inverse">
                    <tr class="hd-clpse">
                        <th>Select</th>
                        <th>Application Number</th>
                        <th>Carrier</th>
                        <th>Application Type</th>
                        <th>User Assigned</th>
                        <th>Status</th>
                        <th>Date Recieved</th>
                        <th>Date Assigned</th>
                        <th class="text-center">View Activity</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="tbl-row" style="border-bottom: 1px solid #ddd;"
                        *ngFor="let item of activities | paginate: { itemsPerPage: pageSize, currentPage: page }; let index = index">
                        <td><input type="checkbox" value="{{item}}" (change)="onChecked($event,item)"></td>
                        <td class="bfr-end-col">{{item.applicationId}}</td>
                        <td class="bfr-end-col">{{item.applicant}}</td>
                        <td class="bfr-end-col">{{item.applicationType}}</td>
                        <td class="bfr-end-col">{{item.userassignedname}}</td>
                        <td class="bfr-end-col">{{item.activityStatus}}</td>
                        <td class="bfr-end-col">{{item.datereceived?.toLocaleString() | date:'dd/MM/yyyy'}}</td>
                        <td class="bfr-end-col">{{item.assignedtogroupyn==true ? '' : item.dateassigned?.toLocaleString() | date:'dd/MM/yyyy'}}</td>
                        <td class="bfr-end-col text-center">
                            <span>
                                <span title="Process activity" id="processAcc"
                                    class="action_btn"
                                    (click)="onView(item)">
                                    <img src="/assets/permit-viewer2.png" class="permit-view" />
                                </span>
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="table_footer">
            <div class="row">
            <div class="col-2">
                <div class="input-group mb-3 rm-brd" *ngIf="activities.length > 0" style="width: 125px !important; height: 30px !important">
                <div class="input-group-prepend">
                    <label class="input-group-text form-control-sm show-h" for="show-id">Show:</label>
                </div>
                <select class="form-control form-control-sm show-h" id="show-id" [(ngModel)]="pageSize" (change)="onChange(pageSize)">
                    <option *ngFor="let key of utility.pageItems" [ngValue]="key">{{ key }}</option>
                </select>
                </div>
            </div>
            </div> 
            <div class="column" style="margin: 0 auto !important">
                <span *ngIf="activities.length == 0 && isLoading == false">
                  <p style="text-align: center !important; margin-bottom: 15px; font-weight: bold;">No workflow activities found.</p>
                </span>
            </div>    
            <div class="column pagination_row">
            <div *ngIf="activities.length > 0">
                <pagination-controls previousLabel="Prev" nextLabel="Next" responsive="true" (pageChange)="pager($event)" style="float: right !important"></pagination-controls>
            </div>
            </div>
        </div>
</div>

<!-- BEGIN POPUP-->

<button data-toggle="modal" data-target="#addEdit" id="secretButton" style="display:none"></button>

<div bsModal #childModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <label class="text-center title">Reassign Activity</label>
                <button type="button" class="close" (click)="onCancel()" data-dismiss="modal" id="closeButton"
                    #closebutton aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body modal-xl">
                <div id="stats-subtitle">
                    <div class="row" *ngIf="!isMultiReassign">
                        <div class="col-xl-6 col-md-12">
                            <div class="card overflow-hidden" style="background-color: #F5F7FA;">
                                <div class="card-content">
                                    <div class="card-body cleartfix">
                                        <div class="media align-items-stretch">
                                            <div class="align-self-center">
                                            </div>
                                            <div class="media-body">
                                                <h5>Hours lapsed since assignment:</h5>
                                            </div>
                                            <div class="align-self-center">
                                                <h5><strong>{{user_data.TimeTaken | number:0}} hour(s)</strong></h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-xl-6 col-md-12">
                            <div class="card" style="background-color: #F5F7FA;">
                                <div class="card-content">
                                    <div class="card-body cleartfix">
                                        <div class="media align-items-stretch">
                                            <div class="align-self-center">
                                            </div>
                                            <div class="media-body">
                                                <h5>Total activities for: <strong>{{assignedusername}}</strong></h5>

                                            </div>
                                            <div class="align-self-center">
                                                <h5><strong>{{user_data.CountAssigned}}</strong></h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div *ngIf="activity_status=='Awaiting Applicant Feedback'" class="col-sm-12">
                            <p style="color: red; text-align:center; padding: 5px;">This workflow activity is Awaiting Applicant Feedback and cannot be re-assigned</p>
                        </div>
                        <div class="col-sm-4">
                            <div class="col-sm-12">
                                <div>
                                    <label>
                                        <strong>Select User To Assign: </strong>
                                    </label>
                                    <select class="form-control form-control-sm" style="min-width: 100%"
                                        [(ngModel)]="selectedUser" [ngClass]="{'disabled':activity_status=='Awaiting Applicant Feedback'}" >
                                        <option [ngValue]="0">--- Please Select ---</option>
                                        <option *ngFor="let user of roleUsers" [ngValue]="user.userName">
                                            {{user.displayName}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-8">
                            <div class="col-sm-12" style="margin-top: 30px">
                                <button class="btn hd-btn-close" style="float: right"
                                    (click)="onCancel()">Cancel</button>
                                <button class="btn hd-btn" style="float: right" (click)="onProceed()"
                                    [disabled]="selectedUser == ''">Proceed</button>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="card" style="background-color: #F5F7FA;" *ngIf="!isMultiReassign">
                        <div class="card-content">
                            <div class="card-body">
                    <div class="row" *ngIf="activities.length>0">
                            <div class="col-md-12" style="text-align: center;">
                              <h6>Application ID: {{application_id}} | Applicant Name: {{applicant_name}} | Application Type: {{application_type}}</h6>
                            </div>
                            <div class="col-md-12">
                           <div class="stepper_wrapper">
                               <div class="stepper_box">
                                 <div class="sticky">
                                   <div class="step_row" *ngFor="let activity of activities; let i = index; let last = last;">
                                     <div class="step step-two" id="other">
                                       {{activity.actiontaken}}
                                     </div>
                                     <div [class]="last ? 'circle last' : 'circle'"  [style.background-color]="activity.currentassignedyn ? background2 : background1">
                                       <img *ngIf="!activity.currentassignedyn"
                                         src="../../assets/stepper-img/done-56@2x.png"			  
                                         height="10"
                                       />
                                       <span style="color: transparent" *ngIf="!activity.currentassignedyn">2</span>
                                     </div>
                                     <div></div>
                                   </div>
                                 </div>
                               </div>
                             
                               <div class="stepper-content">
                                 <div style="margin-top:25px;">
                                 </div>  
                                 <div style="margin-top:25px;" *ngFor="let activity of activities">
                                   <div class="row">
                                       <div class="col-sm-3">
                                           <p><span style="font-weight: 600;">Date Assigned:</span> {{activity.dateassigned | date : "yyyy/MM/dd HH:mm"}}</p>
                                       </div>
                                       <div class="col-sm-3">
                                           <p *ngIf="!activity.currentassignedyn"><span style="font-weight: 600;">Date Completed: </span>{{activity.datecompleted | date : "yyyy/MM/dd HH:mm"}}</p>
                                           <p *ngIf="activity.currentassignedyn"><span style="font-weight: 600;">Date Completed: </span><span style="font-weight: 600; color:green;">Currently Assigned</span></p>
                                       </div>
                                       <div class="col-sm-6">
                                           <p><span style="font-weight: 600;">Status: </span>{{activity.status == 'Approval Recommended' ? 'In Progress' : activity.status}}</p>
                                       </div>
                                   </div>
                                   <br>
                                   <div class="row" >
                                       <div class="col-sm-12" *ngIf="activity.comment">
                                           <p *ngIf="!readmore"><span style="font-weight: 600;">Comment: </span>{{ (activity.comment.length>60) ? (activity.comment | slice:0:60)+'...':(activity.comment) }}
                                               <a *ngIf="activity.comment.length>60" (click)="onReadMore()" style="color:blue; cursor: pointer;"> read more</a>
                                           </p>
                                           <p [innerHTML]="activity.comment" *ngIf="readmore"></p>
                                           <a *ngIf="readmore" (click)="onReadMore()" style="color:blue; cursor: pointer;"> read less</a>
                                       </div>
                                   </div>
                                   <hr>
                                 </div>  
                               </div>
                             </div>
                            </div>
                    </div>
                    </div>
                    </div>
                    </div>
                    <p *ngIf="activities.length<=0">Application tracking details not found</p>
                </div>
            </div>
        </div>

    </div>
</div>

<!-- END POPUP-->